module.exports = __webpack_public_path__ + "img/spencer-krips-press.a79a908a.png";